import React, { useContext } from 'react'
import { FormRow } from '../../../../../_components/Forms/FormRow'
import { Box } from '../../../../../components/Box/Box'
import ScheduleESigningContext from './context'

export const RequestDocuments = ({ setTemplateName, documents }) => {
  const { addTemplate, resetSigners } = useContext(ScheduleESigningContext)

  const clearSelectFields = () => {
    const debtor_contact = document.getElementById('debtor_contact')
    const client_contact = document.getElementById('client_contact')
    if (debtor_contact) {
      debtor_contact.selectedIndex = 0
    }
    if (client_contact) {
      client_contact.selectedIndex = 0
    }
    resetSigners()
  }

  return (
    <Box>
      <FormRow
        className={''}
        disabled={!documents.length}
        id={'client-contact'}
        layout={'inline'}
        onChange={(id) => {
          addTemplate(id)
          setTemplateName(documents.find((document) => document.id == id).name)
          clearSelectFields()
        }}
        options={documents.map((document) => {
          return {
            display: document.label,
            value: document.id,
          }
        })}
        placeholder={'Select Document'}
        type={'select'}
      />
    </Box>
  )
}
